import { call, put, select, takeLatest } from 'redux-saga/effects'
import { SpecialReportsConstants } from '../store/specialReports.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { setSpecialReportsList } from '../store/specialReports.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getSpecialReports() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)

  if (!pcrID) {
    return
  }

  const pcrDocsService = new PcrDocsService(serviceId)

  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    if (pcrDoc?._specialReports && pcrDoc._specialReports.length) {
      yield put(setSpecialReportsList(pcrDoc._specialReports))
    } else {
      yield put(setSpecialReportsList([]))
    }
  } catch (e) {
    yield put(throwPcrException(`getSpecialReports() error: ${e}`))
  }
}

export function* getSpecialReportsSaga() {
  yield takeLatest([SpecialReportsConstants.GET_SPECIAL_REPORTS], performWithMutexHOG, getSpecialReports)
}
